/**
 * The macro section registry: one component per kind, the **slot** each
 * section builder fills (`docs/plans/macro.md`, wave 2).
 *
 * A builder replaces the body of its own file — `CalendarSection.tsx`,
 * `MacroReleasesSection.tsx`, `YieldCurveSection.tsx`, `RelationshipsSection.tsx`,
 * `HavensSection.tsx`, `PositioningSection.tsx` — and never this one, so the
 * builders working in parallel touch their own files and no shared line. The mapped type makes a missing
 * kind, or a component typed for the wrong config, a compile error.
 */

import type { ComponentType } from "react";
import type { MacroKind } from "../../lib/macro-sections";
import type { MacroSectionProps } from "./types";
import CalendarSection from "./CalendarSection";
import HavensSection from "./HavensSection";
import MacroReleasesSection from "./MacroReleasesSection";
import PositioningSection from "./PositioningSection";
import RelationshipsSection from "./RelationshipsSection";
import YieldCurveSection from "./YieldCurveSection";

export const MACRO_SECTIONS: { [K in MacroKind]: ComponentType<MacroSectionProps<K>> } = {
  calendar: CalendarSection,
  macroReleases: MacroReleasesSection,
  yieldCurve: YieldCurveSection,
  relationships: RelationshipsSection,
  havens: HavensSection,
  positioning: PositioningSection,
};
